<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="stepBox">
          <div class="go-back" @click="goBack">返回</div>
          <div class="tabBox" v-if="informationForm.audit_status != 4">
            <el-steps :active="busactive" align-center class="stepsItem">
              <el-step
                :class="
                  index <= informationForm.progress - 1 ? 'changecolor' : ''
                "
                v-for="(item, index) in stepsList"
                :key="index"
                :title="item.title"
                @click.native="changeSteps(index)"
              ></el-step>
            </el-steps>
          </div>
        </div>
        <!--   填写基本信息 -->
        <template v-if="busactive == 0">
          <div class="informationFormBox">
            <el-form
              :model="informationForm"
              :rules="informationRules"
              ref="informationFormRef"
              label-width="120px"
              class="bus-informationForm"
            >
              <el-form-item label="会员类型" prop="type">
                <el-select
                  v-model="informationForm.type"
                  placeholder="请选择会员类型"
                  clearable
                  @change="changeType"
                  disabled
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!--      :disabled="informationForm.progress!='1'"        -->
              <el-form-item label="专委会选择" prop="committee_id">
                <el-select
                  v-model="informationForm.committee_id"
                  placeholder="专委会选择"
                  clearable
                  @change="
                    committeeTitle(informationForm.committee_id, 'committee_id')
                  "
                >
                  <el-option
                    v-for="item in ccompanyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!--             -->
              <el-form-item
                label="单位类别"
                prop="level_long_id"
                v-if="informationForm.type == '2'"
              >
                <el-select
                  v-model="informationForm.level_long_id"
                  placeholder="请选择单位类别"
                  :disabled="informationForm.progress != '1'"
                  @change="
                    levelChange(informationForm.level_long_id, 'level_long_id')
                  "
                >
                  <el-option
                    v-for="item in MemberLevelList"
                    :key="item.level_long_id"
                    :label="item.level_name"
                    :value="item.level_long_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!--              <el-form-item label="委员会说明" prop="resume">-->
              <!--                <el-input class="selitem" show-word-limit v-model="informationForm.resume" type="textarea" rows="4"-->
              <!--                            clearable placeholder="请输入委员会说明"/>-->
              <!--              </el-form-item>-->
            </el-form>
            <!--            v-if="informationForm.progress==1"-->
            <div>
              <!--              v-if="informationForm.progress==1"-->
              <button class="btn next_btn next" @click="next_step">
                下一步
              </button>
              <!--              <button v-else class="btn next_btn next" @click="changeSteps(1)">下一步</button>-->
            </div>
          </div>
        </template>
        <!--   完善资料 个人会员or单位会员 会员类型type区分 -->
        <template v-if="busactive == 1">
          <!--          <el-tabs class="no-border-tabs" v-model="activeName" @tab-click="handleClick" v-if="tabList.length>0">-->
          <!--            <el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.label"-->
          <!--                         :name="item.name"></el-tab-pane>-->
          <!--          </el-tabs>-->
          <!--   个人会员表单组件 -->
          <div class="formBox">
            <!--zhao 个人会员组件引用 -->
            <template v-if="informationForm.type == '1'">
              <individualMember
                ref="individualMemberRef"
                :activeName="activeName"
                :SheetData="SheetData"
                :form_data="informationForm"
              >
              </individualMember>
            </template>
            <!-- 单位会员组件引用 -->
            <template v-if="informationForm.type == '2'">
              <unitMember
                ref="unitMemberRef"
                :activeName="activeName"
                :SheetData="SheetData"
                :form_data="informationForm"
              >
              </unitMember>
            </template>
          </div>
          <div class="footer">
            <button
              class="btn"
              v-if="
                informationForm.audit_status == 4 ||
                informationForm.audit_status == 5
              "
              @click="
                edit_disabled(
                  informationForm.type == '1'
                    ? 'individualMemberRef'
                    : 'unitMemberRef'
                )
              "
            >
              编辑
            </button>
            <button
              class="btn"
              @click="
                dataOrganization(
                  informationForm.progress <= 2 ? 'save' : 'submit'
                )
              "
            >
              保存草稿
            </button>
            <!--            <button class="btn" v-if="(tabList.findIndex((obj)=>{ return obj.name === activeName})+1<tabList.length)"-->
            <!--                    @click="fillOut">{{-->
            <!--                (informationForm.progress > 3) ? '下一步' : '继续填写'-->
            <!--              }}-->
            <!--            </button>-->

            <button
              class="btn next_btn next"
              v-if="
                informationForm.audit_status == 0 ||
                informationForm.audit_status == 5
              "
              @click="dataOrganization('submit')"
            >
              下一步
            </button>
          </div>
        </template>
        <!--   承诺书 -->
        <template v-if="busactive == 2">
          <!--   个人会员 承诺书 富文本-->
          <div class="personageCommitment" v-if="informationForm.type == '1'">
            <h2 style="width: 100%; text-align: center">承诺书</h2>
            <div style="text-indent: 2em; padding: 120px; line-height: 30px">
              本人承诺在注册会员和修改信息过程中所填写的所有信息和上传文件均真实有效，如有虚假，本人自愿承担由此产生的一些责任。
            </div>
            <div style="float: right; margin-right: 120px">
              承诺人：{{ informationForm.full_name }}
            </div>
          </div>
          <!--   单位会员  承诺书 下载pdf 上传签字后的文件-->
          <div class="unitCommitment" v-if="informationForm.type == '2'">
            <div>
              <div class="unitTitle">会员承诺书下载</div>
              <div class="downloadBox">
                <div class="downloadLeft">
                  <img class="pdfIcon" src="../assets/pdf.jpg" alt="" />
                  <div class="unitRight">
                    <div class="unittitle">会员承诺书.pdf</div>
                    <!--                    <div class="unittimes">上传时间：2023/09/20</div>-->
                    <!--                    <div class="unitnum">已下载1次</div>-->
                  </div>
                </div>
                <button class="downloadIcon" @click="down">下载</button>
              </div>
              <div class="unitTitle">上传签字后的文件</div>
              <div>
                <template>
                  <div
                    class="image"
                    v-if="
                      informationForm.promise_file &&
                      informationForm.promise_file.length > 0
                    "
                  >
                    <el-image
                      :src="$imgUrl + informationForm.promise_file"
                    ></el-image>
                    <div class="upload-span">
                      <span
                        class="upload-icon"
                        @click.stop="
                          handlePreview(informationForm.promise_file)
                        "
                        ><i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        class="upload-icon"
                        @click.stop="handleRemove('promise_file')"
                        style="margin-left: 20px"
                        ><i class="el-icon-delete"></i
                      ></span>
                    </div>
                  </div>
                  <div v-else>
                    <el-upload
                      :action="$Url"
                      list-type="picture-card"
                      :headers="headers"
                      :multiple="false"
                      :on-success="
                        (response, file, fileList) => {
                          return handleSuccess(
                            response,
                            file,
                            fileList,
                            'promise_file'
                          );
                        }
                      "
                      :on-error="handleError"
                      :show-file-list="false"
                    >
                      <i class="el-icon-plus">
                        <div class="uploadtxt">请上传高清扫描件</div>
                      </i>
                    </el-upload>
                  </div>
                </template>

                <!--                <el-dialog :visible.sync="dialogVisible">-->
                <!--                  <img width="100%" :src="dialogImageUrl" alt="">-->
                <!--                </el-dialog>-->
              </div>
            </div>
          </div>

          <!--          <div class="checkboxBox">-->
          <!--            <el-checkbox v-model="checked" class="checkbox"-->
          <!--                         :disabled="informationForm.progress!=3"-->
          <!--                         v-if="informationForm.type=='1'"-->
          <!--            >-->
          <!--              <span>勾选即代表同意</span><span>《XXXXXXXXXX》</span>-->
          <!--            </el-checkbox>-->
          <!--          </div>-->

          <div class="footer" style="margin-top: 15px">
            <button
              v-if="informationForm.progress == 3"
              :class="[
                'btn',
                'next',
                countdown_show ? 'btn_disabled' : 'next_btn',
              ]"
              :disabled="countdown_show"
              @click="agree"
            >
              {{
                informationForm.progress == 3 && informationForm.type == "1"
                  ? "我同意"
                  : "已上传"
              }}
              <span v-if="countdown_show">({{ countdown }})</span>
            </button>
            <!--            <button v-if="informationForm.progress==3 && informationForm.type=='2'" class="btn next_btn next"-->
            <!--                    :disabled="countdown_show"-->
            <!--                    @click="agree">已上传-->
            <!--              <span v-if="countdown_show">({{ countdown }})</span>-->
            <!--            </button>-->
          </div>
        </template>
        <!--   等待审核 -->
        <template v-if="busactive == 3">
          <div style="text-align: center; margin-top: 20px">
            <img
              style="height: 80px"
              v-if="
                informationForm.audit_status == 0 ||
                informationForm.audit_status == 1 ||
                informationForm.audit_status == 2
              "
              src="../assets/icon_status1.png"
              alt=""
            />
            <img
              style="height: 80px"
              v-if="informationForm.audit_status == 5"
              src="../assets/icon_status2.png"
              alt=""
            />
            <img
              style="height: 80px"
              v-if="informationForm.audit_status == 3"
              src="../assets/icon_status3.png"
              alt=""
            />
          </div>
          <div
            class="statusBox"
            :class="
              informationForm.audit_status == 0 ||
              informationForm.audit_status == 1 ||
              informationForm.audit_status == 2
                ? 'status1'
                : informationForm.audit_status == 5
                ? 'status2'
                : 'status3'
            "
          >
            <div
              class="statusBox_text"
              v-if="
                informationForm.audit_status == 0 ||
                informationForm.audit_status == 1 ||
                informationForm.audit_status == 2
              "
            >
              <div>您的资料正在审核中</div>
              <div>我们将在5-15个工作日内进行审核，请您耐心等待.</div>
              <div>
                审核结果将以短信形式告知，如有疑问，欢迎您与会员部联系010-8456
                2288-407
              </div>
            </div>
            <div
              class="statusBox_text"
              v-if="informationForm.audit_status == 3"
            >
              <div>您的资料审核通过</div>
            </div>
            <div
              class="statusBox_text"
              v-if="informationForm.audit_status == 5"
            >
              <div>
                您的资料已经被驳回,驳回原因：{{ informationForm.reject_reason }}
              </div>
            </div>
          </div>
          <div class="footer" style="margin-top: 100px">
            <button
              v-if="
                !(
                  informationForm.audit_status == 2 ||
                  informationForm.audit_status == 3 ||
                  this.informationForm.audit_status == 5
                )
              "
              class="btn"
              @click="revoke"
            >
              撤销申请
            </button>
            <button
              v-if="informationForm.audit_status == 5"
              class="btn"
              @click="revoke"
            >
              完善资料
            </button>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-around;
              width: 749px;
              margin: 40px auto;
            "
          >
            <div class="QR_box">
              <img style="height: 150px" src="../assets/QR1.jpg" alt="" />
              <div class="QR_text">中国服装设计师协会微信公众号</div>
            </div>
            <div class="QR_box">
              <img style="height: 150px" src="../assets/QR2.jpg" alt="" />
              <div class="QR_text">中国国际时装周微信公众号</div>
            </div>
            <div class="QR_box">
              <img style="height: 150px" src="../assets/QR3.jpg" alt="" />
              <div class="QR_text">中国国际大学生时装周微信公众号</div>
            </div>
          </div>
        </template>
        <!--   完成缴费 -->
        <template v-if="busactive == 4">
          <payment></payment>
        </template>
      </div>
    </div>
    <!--   预览图片 -->
    <el-dialog :visible.sync="dialogVisible" top="20vh">
      <img
        :src="dialogImageUrl"
        alt=""
        style="
          max-height: 550px;
          max-width: 100%;
          margin: 0 auto;
          display: block;
        "
      />
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title=""
      :visible.sync="committee_text_show"
      width="480px"
      style="height: 520px"
    >
      <div
        style="
          position: absolute;
          top: -20px;
          right: 160px;
          width: 160px;
          height: 42px;
          border-radius: 8px 35px 8px 35px;
          border: 1px solid #ffffff;
          background-color: #e40080;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 42px;
        "
      >
        {{ informationForm.committee_title }}
      </div>
      <!--      <div class="poster" v-html="committee_text"></div>-->
      <span
        >内内容内内内容内内内容内容内容内容内容内容容内内容内容内容内容内容内容容内内容内容内容内容内容内容容容内容内容内容内容容内内容内内内容内容内容内容内容内容容内内容内容内容内容内容内容容内内容内容内容内容内容内容容容内容内容内容内容容内内容内内内容内容内容内容内容内容容内内容内容内容内容内容内容容内内容内容内容内容内容内容容容内容内容内容内容容内内容内容内容内容内容内容容内内容内容内容内容内容内容容内内容内容内容内容内容内容容容内容内容内容内容容</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="committee_text_show = false"
          size="medium"
          >我已知悉</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { personal, enterprise } from "@/utils/individualForm"; //动态表单切换
import {
  MemberBrandLists,
  MemberLevel_lists,
  Members_promiseUp,
  MembersDetail,
  MembersEdit,
  MembersRevoke,
  MembersSubmit,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import individualMember from "../components/individualMember.vue"; // 个人会员表单信息
import unitMember from "../components/unitMember.vue"; // 单位会员表单信息
import payment from "../views/payment.vue"; // 缴费页
import { area } from "../utils/area"; //国家地区
export default {
  components: { top, navMenu, individualMember, unitMember, payment },
  name: "busInformation",
  data() {
    return {
      countdown: 5, //计时器
      countdown_show: true, //计时器
      headers: {
        token: localStorage.getItem("token"),
      },
      ccompanyList: JSON.parse(localStorage.getItem("ccompanyList")),
      SheetData: {},
      form_data: {},
      typeList: [
        {
          id: "1",
          name: "个人委员会",
        },
        {
          id: "2",
          name: "单位委员会",
        },
      ],
      MemberLevelList: [],
      isigned: "",
      checked: true,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      radio: 3,
      text: "您的资料正在审核中",
      status: 1,
      committee_text_show: false, //富文本弹窗
      brandTitle: "", //品牌弹窗名称
      brandForm: {
        //品牌表单数据
        id: "", //品牌id
        ownership: "", //所属类型 1:个人会员，2:单位会员
        user_long_id: "", //所关联的用户长ID
        brand_name: "", //品牌名称
        website: "", //品牌官网
        brand_type: "", //品牌类别
        registration_time: "", //注册时间
        registration_address: "", //注册地
        trademark: [], //商标注册证或代理授权
        category: "", //品类
        offline_store: "", //线上分布/线上店铺
        online_store: "", //入驻电商平台
        SKU: "", //年sku数
        product_price: "", //产品及价位
        honors: "", //奖项及荣誉
      },
      brandFormRules: {
        //品牌表单验证
      },
      active: 10,
      busactive: 10,
      page_no: 1,
      page_size: 10,
      total: 100,
      stepsList: [
        { title: "登记" },
        { title: "完善资料" },
        { title: "承诺书" },
        { title: "等待审核" },
        { title: "完成缴费" },
      ],
      tabList: [],
      informationForm: {
        //登记
        audit_status: 4,
        type: "",
        level_long_id: "",
        committee_id: "",
        promise_file: "",
      },
      informationRules: {
        type: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        committee_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        level_long_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //基本信息表单验证

      activeName: "basic",
      loading: false,
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      mark: "",
      result: [],
    };
  },
  mounted() {
    let ccccc = [
      "Company_clothing",
      "Company_park",
      "Company_business",
      "Company_colleges",
      "FModel_company",
      "FModel_train",
      "FModel_other",
      "FModel_colleges",
      "Brand_brand",
    ];
    let mmm = [];
    for (let i = 0; i < ccccc.length; i++) {
      let dd = this.toOneArray(enterprise[ccccc[i]].basic);
      dd.forEach((items) => {
        if (items.prop) {
          mmm.push(items.prop + "-" + items.label);
        }
      });
    }
    let sss = [...new Set(mmm)];
    // const uniqueArr = [...new Map(mmm.map(item => [item.prop, item])).values()];
    console.log(sss, "222222222222222222");

    this.init();
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    let index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/aptitude";
    });
    this.active = index;
    this.mark = this.$route.query.mark;
  },
  created() {},
  watch: {
    busactive(index) {
      if (index == 2) {
        this.countdown_show = true;
        this.timer();
      }
    },
  },
  methods: {
    async init() {
      let userData = JSON.parse(localStorage.getItem("userdata"));
      this.informationForm.type = userData.type;
      this.informationForm.committee_id = userData.committee_id;
      this.informationForm.committee_title = userData.committee_title;
      console.log(this.informationForm);
      this.changeType();
      const arr = await this.getMemberLevel_lists();
      this.getMembersDetail(true);
    },
    // 获取会员等级
    getMemberLevel_lists() {
      let id = this.informationForm.committee_id;
      let data = this.$qs.stringify({ committee_id: id });
      return MemberLevel_lists(data)
        .then((res) => {
          if (res.code == 1) {
            this.MemberLevelList = res.data.lists;
            if (this.informationForm.type == 1) {
              this.informationForm.level_long_id =
                this.MemberLevelList[0].level_long_id;
            }
            return res.data.lists;
          } else {
            this.$message.warning(res.msg);
            return null;
          }
        })
        .catch((error) => {
          // 处理可能出现的错误
          console.error("Error fetching member level lists:", error);
          throw error;
        });
    },

    layout() {
      if (this.informationForm.type == "1") {
        //个人根据专委会id变
        switch (this.informationForm.committee_id) {
          case 4:
            this.SheetData = personal.Fashion;
            break;
          case 3:
            this.SheetData = personal.Accessory;
            break;
          case 5:
            this.SheetData = personal.Academic;
            break;
          case 6:
            this.SheetData = personal.Technology;
            break;
          case 7:
            this.SheetData = personal.DDisplay;
            break;
          default:
            break;
        }
      } else {
        if (this.informationForm.level_long_id) {
          let case_val = this.MemberLevelList.filter((item) => {
            return item.level_long_id == this.informationForm.level_long_id;
          }); //单位
          switch (case_val[0].unique_mark) {
            case "Company_clothing":
              this.SheetData = enterprise.Company_clothing;
              this.tabChange();
              break;
            case "Company_park":
              this.SheetData = enterprise.Company_park;
              this.changeType();
              break;
            case "Company_business":
              this.SheetData = enterprise.Company_business;
              this.changeType();
              break;
            case "Company_colleges":
              this.SheetData = enterprise.Company_colleges;
              this.changeType();
              break;
            case "FModel_company":
              this.SheetData = enterprise.FModel_company;
              this.changeType();
              break;
            case "FModel_train":
              this.SheetData = enterprise.FModel_train;
              this.changeType();
              break;
            case "FModel_other":
              this.SheetData = enterprise.FModel_other;
              this.changeType();
              break;
            case "FModel_colleges":
              this.SheetData = enterprise.FModel_colleges;
              this.changeType();
              break;
            case "Brand_brand":
              this.SheetData = enterprise.Brand_brand;
              this.tabChange();
              break;
            default:
              break;
          }
        }
      }
    },
    //   改变步骤条
    changeSteps(index) {
      if (Number(index) + 1 <= Number(this.informationForm.progress)) {
        this.getMembersDetail();
        this.busactive = index;
      }
    },
    // 赵 填写基本信息下一步按钮
    next_step() {
      this.$refs["informationFormRef"].validate((valid) => {
        if (valid) {
          console.log(this.informationForm);
          this.informationForm.progress = 2;
          this.changeType();

          // let type = this.informationForm.type

          // let formData={}
          // if (type == '1') {
          //   this.saveMembersEdit(this.informationForm)
          //   this.busactive = 1
          // } else {
          this.layout();
          this.saveMembersEdit(this.informationForm);
          this.busactive = 1;
          // }
        }
      });
    },
    //  选择会员类型
    changeType(e) {
      let tabList = [];
      if (this.informationForm.type == "1") {
        //个人会员
        tabList = [
          { name: "basic", label: "基本信息" },
          { name: "profile", label: "资料填报" },
          {
            name: "ancillary",
            label: "附属信息",
          },
        ];
        let id = this.informationForm.committee_id;
        if (id == 3 || id == 4 || id == 5) {
          //仅时装配饰和学术
          tabList.push({ name: "brand", label: "品牌信息" });
        }
      } else {
        //单位会员 刚进来默认没有
        tabList = [
          { name: "basic", label: "基本信息" },
          { name: "ancillary", label: "附属信息" },
        ];
        // let id = this.informationForm.committee_id
        // if (id == 3 || id == 4 || id == 5) {//仅品牌 服装上下游
        //   tabList.push({name: 'brand', label: '品牌信息'})
        // }
      }
      this.tabList = tabList;
    },
    // 修改单位tab切换
    tabChange() {
      this.tabList = [
        { name: "basic", label: "基本信息" },
        { name: "ancillary", label: "附属信息" },
        {
          name: "brand",
          label: "品牌信息",
        },
      ];
    },
    // 获取详细信息 zhao 2024年11月6日15:59:02
    getMembersDetail(init) {
      let data = this.$qs.stringify({ type: this.informationForm.type });
      let formName =
        this.informationForm.type == "1"
          ? "individualMemberRef"
          : "unitMemberRef";
      MembersDetail(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.informationForm = res.data;
            // this.informationForm.progress = res.data.progress
            // this.informationForm.level_long_id = res.data.level_long_id
            // this.informationForm.promise_status = res.data.promise_status
            // this.informationForm.promise_file = res.data.promise_file
            // this.informationForm.audit_status = res.data.audit_status
            // this.checked = res.data.promise_status == 1
            this.layout();
            // if(this.informationForm.type==2){
            //   this.levelChange()
            // }
            // res.data.city = res.data.city?res.data.city.split(">"):[]
            console.log(this.informationForm);
            if (this.informationForm.type == 1) {
              this.informationForm.city = res.data.city
                ? res.data.city.split(">")
                : [];
              let weibo =
                  this.informationForm.weibo.length > 0
                    ? JSON.parse(this.informationForm.weibo)
                    : ["", ""],
                tiktok =
                  this.informationForm.tiktok.length > 0
                    ? JSON.parse(this.informationForm.tiktok)
                    : ["", ""],
                red_book =
                  this.informationForm.red_book.length > 0
                    ? JSON.parse(this.informationForm.red_book)
                    : ["", ""],
                other_platforms =
                  this.informationForm.other_platforms.length > 0
                    ? JSON.parse(this.informationForm.other_platforms)
                    : ["", ""];
              this.informationForm.weibo_account = weibo[0];
              this.informationForm.weibo = weibo[1];
              this.informationForm.tiktok_account = tiktok[0];
              this.informationForm.tiktok = tiktok[1];
              this.informationForm.red_book_account = red_book[0];
              this.informationForm.red_book = red_book[1];
              this.informationForm.other_platforms_account = other_platforms[0];
              this.informationForm.other_platforms = other_platforms[1];
            }
            // if (this.informationForm.type == 1) {
            //   this.informationForm.designers_type = res.data.designers_type ? res.data.designers_type.split(",") : []
            //   console.log( this.informationForm.designers_type,this.$refs['individualMemberRef'])
            //   this.informationForm.designers_type.forEach((item, index) => {
            //     if (item.includes('为品牌或企业提供设计服务')) {
            //       this.$refs['individualMemberRef'].Collaborated_before = item.substring(item.lastIndexOf("&") + 1)
            //       this.informationForm.designers_type[index] = item.substring(0, item.lastIndexOf("&"))
            //     }
            //   })
            //   this.informationForm.designers_type.forEach((item, index) => {
            //     if (item.includes('其他')) {
            //       this.$refs['individualMemberRef'].Other_notes = item.substring(item.lastIndexOf("&") + 1)
            //       this.informationForm.designers_type[index] = item.substring(0, item.lastIndexOf("&"))
            //     }
            //   })
            //
            //   this.$refs['individualMemberRef'].Collaborated_before_show = this.informationForm.designers_type.some(item => {
            //     return item == '为品牌或企业提供设计服务'
            //   })
            //   this.$refs['individualMemberRef'].Other_notes_show = this.informationForm.designers_type.some(item => {
            //     return item == '其他'
            //   })
            //   this.informationForm.major_field = res.data.major_field ? res.data.major_field.split(",") : []
            //   console.log(this.informationForm.major_field)
            //   this.informationForm.major_field.forEach((item, index) => {
            //     if (item.includes('其他')) {
            //       this.$refs['individualMemberRef'].major_field_Other_notes = item.substring(item.lastIndexOf("&") + 1)
            //       this.informationForm.major_field[index] = item.substring(0, item.lastIndexOf("&"))
            //     }
            //   })
            //   this.$refs['individualMemberRef'].major_field_show = this.informationForm.major_field.some(item => {
            //     return item == '其他'
            //   })
            //   this.informationForm.course_direction = res.data.course_direction ? res.data.course_direction.split(",") : []
            //   this.informationForm.course_direction.forEach((item, index) => {
            //     if (item.includes('其他')) {
            //       this.$refs['individualMemberRef'].course_direction_Other_notes = item.substring(item.lastIndexOf("&") + 1)
            //       this.informationForm.course_direction[index] = item.substring(0, item.lastIndexOf("&"))
            //     }
            //   })
            //   this.$refs['individualMemberRef'].course_direction_show = this.informationForm.course_direction.some(item => {
            //     return item == '其他'
            //   })
            // }

            this.informationForm.training_type = res.data.training_type
              ? res.data.training_type.split(",")
              : [];
            if (init) {
              this.informationForm.level_long_id =
                this.MemberLevelList[0].level_long_id;
              if (this.informationForm.audit_status == 4) {
                this.busactive = 1;
              } else {
                this.busactive = Number(this.informationForm.progress) - 1;
              }
            }
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //   完善信息表单步骤切换
    handleClick(tab, event) {
      this.activeName = tab.name;
      // if (tab.name != 'brand') {
      //   this.getMembersDetail()
      // }
    },
    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 5;
        this.countdown_show = false;
        return;
      }
      setTimeout(() => {
        this.countdown = this.countdown - 1;
        this.timer();
      }, 1000);
    },
    // 赵 承诺书同意
    agree() {
      let formData = {
        progress: 4,
        type: this.informationForm.type,
        promise_status: this.checked ? 1 : 0,
      };
      formData.promise_status =
        this.informationForm.type == "2" ? 1 : formData.promise_status;
      if (formData.promise_status == 1) {
        if (this.informationForm.type == "1") {
          this.MembersPromiseUp(formData);
        } else {
          formData.promise_file = this.informationForm.promise_file;
          this.MembersPromiseUp(formData);
        }
      } else {
        this.$message.warning("请勾选");
      }
    },
    MembersPromiseUp(formData) {
      // this.$confirm("同意承诺书", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      Members_promiseUp(formData).then((res) => {
        if (res.code == 1) {
          this.getMembersDetail();
          this.$message.success(res.msg);
          this.busactive = 3;
        } else {
          this.$message.warning(res.msg);
        }
      });

      // })
    },

    // 赵 继续填写
    fillOut() {
      let activeName = this.activeName;
      switch (activeName) {
        case "basic":
          if (this.informationForm.type == "1") {
            //个人会员
            this.activeName = "profile";
          } else {
            this.activeName = "ancillary";
          }
          break;
        case "profile":
          this.activeName = "ancillary";
          break;
        case "ancillary":
          let aa = this.tabList.filter((item) => {
            return item.name == "brand";
          });
          if (aa.length > 0) {
            //个人会员
            this.activeName = "brand";
          }
          break;
        default:
          break;
      }
    },
    // 解决数组嵌套
    toOneArray(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i])) {
          this.toOneArray(arr[i]);
        } else {
          this.result.push(arr[i]);
        }
      }
      return this.result;
    },

    edit_disabled(ref) {
      this.$refs[ref].change_form_disabled();
    },
    //赵 保存 提交 草稿 数据处理
    async dataOrganization(order) {
      this.loading = true;
      let type = this.informationForm.type;
      let formName = type == "1" ? "individualMemberRef" : "unitMemberRef";
      let formData =
        type == "1"
          ? JSON.parse(
              JSON.stringify(this.$refs[formName].individualMemberForm)
            )
          : JSON.parse(JSON.stringify(this.$refs[formName].unit_memberForm));
      formData.type = type;
      // formData.committee_id = this.informationForm.committee_id
      // formData.committee_title = this.informationForm.committee_title
      // formData.level_long_id = this.informationForm.level_long_id
      if (type == 1) {
        formData.city = formData.city.length > 0 ? formData.city.join(">") : "";
        let weibo = [],
          tiktok = [],
          red_book = [],
          other_platforms = [];
        weibo = [formData.weibo_account, formData.weibo];
        tiktok = [formData.tiktok_account, formData.tiktok];
        red_book = [formData.red_book_account, formData.red_book];
        other_platforms = [
          formData.other_platforms_account,
          formData.other_platforms,
        ];
        formData.weibo = JSON.stringify(weibo);
        formData.tiktok = JSON.stringify(tiktok);
        formData.red_book = JSON.stringify(red_book);
        formData.other_platforms = JSON.stringify(other_platforms);
      }

      let idArr = [3, 4, 5];
      let mm = 0;
      let qq = idArr.some((item) => {
        return item == formData.committee_id;
      });
      let cc = [];
      if (qq && formData.designers_type.length > 0) {
        cc = formData.designers_type.filter((item) => {
          return (
            item == "兼/全职就职于市场品牌或企业" ||
            item == "创立或联合创立品牌"
          );
        });
        if (cc.length > 0) {
          mm = await this.getMemberBrandLists();
        }
      }

      if (type == 1) {
        if (this.$refs["individualMemberRef"].Collaborated_before_show) {
          formData.designers_type.forEach((item, index) => {
            if (item == "为品牌或企业提供设计服务") {
              formData.designers_type[index] =
                item +
                "&" +
                this.$refs["individualMemberRef"].Collaborated_before;
            }
          });
        }
        if (this.$refs["individualMemberRef"].Other_notes_show) {
          formData.designers_type.forEach((item, index) => {
            if (item == "其他") {
              formData.designers_type[index] =
                item + "&" + this.$refs["individualMemberRef"].Other_notes;
            }
          });
        }
        if (this.$refs["individualMemberRef"].major_field_show) {
          formData.major_field.forEach((item, index) => {
            if (item == "其他") {
              formData.major_field[index] =
                item +
                "&" +
                this.$refs["individualMemberRef"].major_field_Other_notes;
            }
          });
        }
        if (this.$refs["individualMemberRef"].course_direction_show) {
          formData.course_direction.forEach((item, index) => {
            if (item == "其他") {
              formData.course_direction[index] =
                item +
                "&" +
                this.$refs["individualMemberRef"].course_direction_Other_notes;
            }
          });
        }
      }

      formData.designers_type =
        formData.designers_type && formData.designers_type.length > 0
          ? formData.designers_type.join(",")
          : "";
      formData.major_field =
        formData.major_field && formData.major_field.length > 0
          ? formData.major_field.join(",")
          : "";
      formData.course_direction =
        formData.course_direction && formData.course_direction.length > 0
          ? formData.course_direction.join(",")
          : "";
      formData.training_type =
        formData.training_type && formData.training_type.length > 0
          ? formData.training_type.join(",")
          : "";
      // if (type == "1") {
      if (order == "save") {
        formData.progress =
          Number(formData.progress) > 2 ? formData.progress : 2;
        this.saveMembersEdit(formData);
      } else {
        let obj = this.$refs[formName].validateForm();
        if (obj.flag) {
          if (qq && cc.length > 0 && mm == 0) {
            this.loading = false;
            return this.$message.warning(`请先创建品牌`);
          }
          formData.progress =
            Number(formData.progress) > 3 ? formData.progress : 3;
          this.currencyMemberSubmit(formData);
        } else {
          this.loading = false;
          this.result = [];
          this.toOneArray(this.SheetData.basic);
          console.log(this.result);
          const Array = this.result.filter((item) => {
            if (item.prop) {
              return item.prop == obj.firstInvalidField;
            }
          });
          this.$message.warning(
            `请填写${Array[0].label}，以及注意其他必填项的保存`
          );
        }
      }
      // } else {
      //   if (order == 'save') {
      //     this.unitMemberEdit(formData)
      //   } else {
      //     this.$refs[formName].validate((valid) => {
      //       if (valid) {
      //         this.unitMemberSubmit(formData)
      //       } else {
      //         this.$message.warning('请将数据填写完整');
      //       }
      //     })
      //   }
      // }
    },
    revoke(type) {
      this.$confirm(
        this.informationForm.audit_status != 5
          ? "确定要撤销等待审核的信息吗?"
          : "请完善资料后重新提交。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let data = {
          progress: this.informationForm.audit_status == 5 ? 2 : 1,
          type: this.informationForm.type,
        };
        MembersRevoke(data).then(async (res) => {
          if (res.code == 1) {
            this.$message.success(res.msg);
            this.getMembersDetail();
            this.informationForm.progress =
              this.informationForm.audit_status == 5 ? 2 : 1;
            this.busactive = this.informationForm.audit_status == 5 ? 1 : 0;
          } else {
            this.$message.warning(res.msg);
          }
        });
      });

      // this.loading = true;
      // let formName = type == '1' ? 'individualMemberRef' : 'unitMemberRef'
      // let formData = type == '1' ? this.$refs[formName].individualMemberForm : this.$refs[formName].unit_memberForm
      // if (type == '1') {
      //   formData.type = this.informationForm.type
      //   formData.committee_id = this.informationForm.committee_id
      //   formData.committee_title = this.informationForm.committee_title
      //   this.saveMembersEdit(formData)
      //
      // } else {
      //
      // }
    },
    //个人 企业 保存接口
    saveMembersEdit(data) {
      MembersEdit(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$message.success(res.msg);

            let formName =
              this.informationForm.type == "1"
                ? "individualMemberRef"
                : "unitMemberRef";
            this.informationForm.progress = res.data.progress;
            this.informationForm.level_long_id = res.data.level_long_id;
            let userData = JSON.parse(localStorage.getItem("userdata"));
            userData.committee_id = res.data.committee_id;
            userData.committee_title = res.data.committee_title;
            localStorage.setItem("userdata", JSON.stringify(userData));
            // this.layout()
            // res.data.city = res.data.city ? res.data.city.split(">") : []
            //
            // this.$refs[formName].updateData(res.data)
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //个人 企业 提交接口
    currencyMemberSubmit(data) {
      MembersSubmit(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.informationForm = res.data;
            this.busactive = this.informationForm.audit_status == 4 ? 1 : 2;
            console.log(this.busactive);
            // this.fillOut()
            this.$message.success(res.msg);
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 有条件查询品牌列表 条件下品牌必填
    getMemberBrandLists() {
      let data = this.$qs.stringify({
        page_no: 1,
        page_size: 10,
        type: this.informationForm.type,
      });
      return MemberBrandLists(data)
        .then((res) => {
          if (res.code == 1) {
            return res.data.count;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    committeeTitle(e, name) {
      let title = null;
      title = this.ccompanyList.filter((item) => {
        return item.id == e;
      });
      this.informationForm.committee_title = title[0].name;
      this.changeType();
      this.getMemberLevel_lists();
      // this.layout(name)
      this.informationForm.level_long_id = "";
      this.committee_text_show = true;
    },

    // 下载
    down() {
      let file = "https://oss.indata3.com/cfa/attach/2024/files/会员承诺书.pdf";
      window.open(file, "_blank");
    }, // 获取责任书

    // 返回
    goBack() {
      this.$router.back();
    },

    //滑动到错误对应位置
    scrollToFormError() {
      // 获取第一个校验错误的元素
      const element = document.querySelectorAll(".el-form-item__error")[0];
      // 滚动到错误元素对应位置
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    handleMainProductChange(value) {
      this.collapseTags = value.length >= 5;
    },
    handleAreaChange(value) {
      this.collapseAreaTags = value.length >= 4;
    },
    //zhao 上传成功
    handleSuccess(response, file, fileList, field) {
      if (response.code == 1) {
        this.$message.success(response.msg);
        this.informationForm[field] = response.data.uri;
      } else {
        this.$message.error(response.msg);
      }
    },
    // zhao 上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.msg);
    },
    //赵 预览图片 通用
    handlePreview(file) {
      this.dialogImageUrl = this.$imgUrl + file;
      this.dialogVisible = true;
    },
    //zhao  删除图片
    handleRemove(field) {
      console.log(this.informationForm[field]);

      this.informationForm[field] = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    levelChange(id, name) {
      // 只针对单位会员
      let case_val = this.MemberLevelList.filter((item) => {
        return item.level_long_id == this.informationForm.level_long_id;
      }); //单位
      switch (case_val[0].unique_mark) {
        case "Company_clothing":
          this.SheetData = enterprise.Company_clothing;
          this.tabChange();
          break;
        case "Company_park":
          this.SheetData = enterprise.Company_park;
          this.changeType();
          break;
        case "Company_business":
          this.SheetData = enterprise.Company_business;
          this.changeType();
          break;
        case "Company_colleges":
          this.SheetData = enterprise.Company_colleges;
          this.changeType();
          break;
        case "FModel_company":
          this.SheetData = enterprise.FModel_company;
          this.changeType();
          break;
        case "FModel_train":
          this.SheetData = enterprise.FModel_train;
          this.changeType();
          break;
        case "FModel_other":
          this.SheetData = enterprise.FModel_other;
          this.changeType();
          break;
        case "FModel_colleges":
          this.SheetData = enterprise.FModel_colleges;
          this.changeType();
          break;
        case "Brand_brand":
          this.SheetData = enterprise.Brand_brand;
          this.tabChange();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.unitTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7f8fa4;
  margin: 30px 0 10px;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}

.status2 {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}

.status3 {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}

.changecolor {
  cursor: pointer;

  /deep/ .el-step__line {
    background-color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__head.is-wait {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__title.is-wait {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(228, 0, 128, 0.4);
  }
}

//   步骤条样式修改
.stepBox {
  //width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;

  .go-back {
    position: absolute;
    left: 0;
    top: 0;
  }

  /deep/ .el-step.is-center .el-step__line {
    left: 68%;
    right: -22%;
  }

  /deep/ .el-step__icon {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }

  ///deep/ .el-step__head.is-wait {
  //  color: #C7C7CC;
  //  border-color: #C7C7CC;
  //}

  /deep/ .el-step__head.is-process {
    border-color: #e40080;
    color: #e40080;

    .el-step__line {
      background: #e40080;
    }
  }

  /deep/ .el-step__head.is-finish {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);

    .el-step__line {
      background: rgba(228, 0, 128, 0.4);
    }
  }

  /deep/ .el-step__title.is-finish {
    color: rgba(228, 0, 128, 0.4);
    font-size: 12px;
  }

  ///deep/ .el-step__title.is-wait {
  //  font-family: PingFangSC, PingFang SC;
  //  font-weight: 400;
  //  font-size: 12px;
  //  color: #8E8E93;
  //}

  /deep/ .el-step__title.is-process {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #e40080;
  }
}

//   步骤条盒子
.stepsItem {
  width: 692px !important;
}

//   基本信息表单盒子
.informationFormBox {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bus-informationForm {
    width: 560px !important;

    /deep/ .el-select {
      width: 400px;
    }
  }

  .next {
    margin-top: 190px;
  }
}

.apply-phone {
  /deep/ .el-input__inner {
    width: 400px;
    height: 36px;
    border: 1px solid #cad2dd;
  }
}

.formBox {
  //height: 650px;
  //overflow: auto;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.QR_box {
  text-align: center;
}

.QR_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}

.checkboxBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 94px;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.searchBtnBox {
  margin-bottom: 20px;
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.selitem {
  width: 100%;
}

// 完成缴费
.completePaymentBox {
  width: 880px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  margin: 20px auto 0;
  padding: 30px 20px 66px;
  box-sizing: border-box;

  .completePaymentTips {
    width: 252px;
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .completePaymentLine {
    width: 100%;
    height: 1px;
    background: #eeeeee;
  }

  .payInfoBox {
    display: flex;
    align-items: center;
    margin: 13px 0;

    .left {
      span {
        display: inline-block;
      }

      span:nth-child(1) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #1d1d1d;
      }

      span:nth-child(2) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #ff4d4f;
      }
    }

    .right {
      margin-left: 185px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #555555;

      .rightInfo {
        display: flex;
        margin: 10px 0;

        .rightItem {
          margin-right: 70px;
        }
      }
    }
  }

  .paytitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #1d1d1d;
    margin-top: 10px;
  }

  .upload-demo {
    margin-left: 26px;
    display: flex;
    margin-top: 17px;
  }

  /deep/ .el-upload-list__item {
    margin-top: 0;
  }

  .changepay {
    display: flex;
    align-items: flex-start;
  }

  .wyjf {
    margin-top: 39px;
  }

  .radioItem {
    display: inline-block;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #eeeeee;
    margin-top: 9px;

    .radioIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 3px;
    }
  }

  .codeBox {
    display: flex;
    width: 345px;
    height: 116px;
    padding: 7px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dedede;
    margin-top: 20px;

    .code {
      width: 102px;
      height: 102px;
    }

    .codeinfo {
      margin-left: 10px;

      .info1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
      }

      .info2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #ff4d4f;
        margin-top: 10px;
      }

      .info3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-top: 16px;
      }
    }
  }
}

.upload-btn {
  width: 61px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
}

.search-btn:hover {
  background: #e40080;
}

.search-btn:active {
  background: #e40080;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

.personageCommitment {
  padding-top: 30px;
  width: 100%;
  height: 490px;
  background: #f2f6fb;
}

.unitCommitment {
  width: 100%;
  height: 490px;
}

.downloadBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 383px;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid #cad2dd;
}

.downloadLeft {
  display: flex;
}

.downloadIcon {
  cursor: pointer;
  width: 60px;
  height: 26px;
  background: #e40080;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #ffffff;
  border: none;
}

.pdfIcon {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}

.unitRight {
  margin-left: 20px;

  .unittitle {
    line-height: 68px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #2c2c2e;
  }

  .unittimes {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 15px 0;
  }

  .unitnum {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
  }
}

.poster {
  width: 100%;
  display: block;
  margin-top: 50px;
}

/deep/ .el-dialog__footer {
  text-align: center;
}
</style>
